export default class FiscalDocumentDetailLineIncomingDto {
    #lineNumber;
    #quantity;
    #description;
    #unitPrice;
    #vat;
    #totalPrice;
    #nature;

    /**
     * Constructor.
     *
     * @param lineNumber {number}
     * @param quantity {number}
     * @param description {string}
     * @param unitPrice {number}
     * @param vat {number}
     * @param totalPrice {number}
     * @param nature {string|null}
     */
    constructor(
        lineNumber,
        quantity,
        description,
        unitPrice,
        vat,
        totalPrice,
        nature = null
    ) {
        this.#lineNumber = lineNumber;
        this.#quantity = quantity;
        this.#description = description;
        this.#unitPrice = unitPrice;
        this.#vat = vat;
        this.#totalPrice = totalPrice;
        this.#nature = nature;
    }

    get lineNumber() {
        return this.#lineNumber;
    }

    get quantity() {
        return this.#quantity;
    }

    get description() {
        return this.#description;
    }

    get unitPrice() {
        return this.#unitPrice;
    }

    get vat() {
        return this.#vat;
    }

    get totalPrice() {
        return this.#totalPrice;
    }

    get nature() {
        return this.#nature;
    }
}
